"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--urvrsw"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-radius: 18px;\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    background: white;\n    box-shadow: 0px 4px 8px rgba(46, 42, 37, 0.16);\n"], ["\n    border-radius: 18px;\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    background: white;\n    box-shadow: 0px 4px 8px rgba(46, 42, 37, 0.16);\n"])));
exports.Wrapper = Wrapper;
var templateObject_1;